import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_booking = async (booking) => {
    try {
        const data = {
            customer: booking?.customer,
            quote: booking?.quote,
            number: booking?.number,
            date: booking?.date,
            expiry_date: booking?.expiry_date,
            salesman: booking?.salesman,
            details: booking?.details,
            subtotal: booking?.subtotal,
            taxamount: booking?.taxamount,
            discount: booking?.discount,
            total: booking?.total,
            note: booking?.note,
            deposits: booking?.deposits || [],
            status: booking?.status,
        };

        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/create-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const update_booking = async (booking) => {
    try {
        const data = {
            id: booking?.id,
            customer: booking?.customer,
            number: booking?.number,
            date: booking?.date,
            expiry_date: booking?.expiry_date,
            salesman: booking?.salesman,
            details: booking?.details,
            subtotal: booking?.subtotal,
            taxamount: booking?.taxamount,
            discount: booking?.discount,
            total: booking?.total,
            note: booking?.note,
            deposits: booking?.deposits || [],
            status: booking?.status,
        };

        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/update-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_booking = async (booking) => {
    try {
        const data = { id: booking?.id };
        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/get-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_all_bookings = async (booking) => {
    try {
        const data = {
            search: booking?.search,
            sort: booking?.sort,
            status: booking?.status,
            date: booking?.date,
            page: booking?.page,
        };

        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/get-all-bookings`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const cancel_booking = async (booking) => {
    try {
        const data = { id: booking?.id };
        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/cancel-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const convert_booking = async (booking) => {
    try {
        const data = { id: booking?.id };
        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/convert-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

const delete_booking = async (booking) => {
    try {
        const data = { id: booking?.id };
        const token = localStorage.getItem("user");
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const response = await axios.post(`${APIURL}/delete-booking`, data, config);
        return response?.data;
    } catch (error) {
        return error;
    }
};

export {
    create_booking,
    update_booking,
    get_booking,
    get_all_bookings,
    cancel_booking,
    convert_booking,
    delete_booking,
};